import { render, staticRenderFns } from "./HistoryAudioPlayer.vue?vue&type=template&id=67fc7c56&"
import script from "./HistoryAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./HistoryAudioPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports